const { cELM, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");
const sanitizer = require('../../utils/sanitizer');

class TextInput {
  constructor(data, placeholder, type, validator) {
    this._data = data;
    this.customBoxText = ((this._data || {}).customTexts || {}).boxText || null;
    this.element = cELM("div", "option-block");
    this.placeholder = this.customBoxText || placeholder || "";
    this.type = type;

    this.validator = validator;
    this.elements = null;
  }

  getELM() {
    return this.element;
  }

  setAutoFocus(v) {
    this._autofocus = v;
  }

  getHTML() {
    const _self = this;
    const inputEl = cELM("input", this.type === "number" ? "number-input mr" : "text-input mr");
    inputEl.placeholder = this.placeholder;
    inputEl.type = this.type || "text";
    inputEl.maxLength = 256;

    if (this.type === "number") {
      inputEl.pattern = "[0-9]*";
      inputEl.onkeydown = function(evt) {
        // disable inputing "e"
        return evt.keyCode !== 69;
      };
    }

    if(typeof this._autofocus === 'undefined' || this._autofocus) {
      inputEl.autofocus = true;
    }

    const buttonEl = cELM("div", "go-button", getLngTxt("button.submit"));
    buttonEl.onclick = function(evt) {
      if(!buttonEl.classList.contains('go-button-active') || (inputEl.value || '').length <= 0){
        return;
      }

      const op = sanitizer.sanitizeString(inputEl.value);

      if (!op) {
        return;
      }
      
      inputEl.blur();
      inputEl.classList.remove("invalid");

      if (_self.validator && !_self.validator(op)) {
        inputEl.classList.add("invalid");
        inputEl.focus();
        return;
      }

      let data = (window.__FN_DATA_WRAPPER) ? window.__FN_DATA_WRAPPER(op) : op;

      data = (typeof data == 'string') 
          ? { text: data, id: _self._data.id }
          : { ...data, id: _self._data.id };

      data.answerKey = _self._data.answerKey;

      Chat.default.send(data, null, _self.element);

    };

    const fnChange = function(evt) {
      if (evt.key === "Enter") {
        buttonEl.click();
      }

      setTimeout(() => {
        const sanitizedInput = sanitizer.sanitizeString(inputEl.value);
        if (sanitizedInput.length > 0) {
          buttonEl.classList.add("go-button-active");
        } else {
          buttonEl.classList.remove("go-button-active");
        }
      }, 10);
    };

    inputEl.onkeyup = fnChange;
    inputEl.onchange = fnChange;


    this.element.addELM(Wrap4Arrow(inputEl, true));
    this.element.addELM(buttonEl);
    this.elements = { el: inputEl, btn: buttonEl };

    return this.element;
  }

  reset() {
    this.element.firstChild.value = "";
    this.element.firstChild.focus();
  }

  focus() {
    // this.elements.el.click();
    //this.elements.el.focus();
  }
}

module.exports = TextInput;
